<p-dialog
  [(visible)]="visible"
  [modal]="true"
  [maximizable]="true"
  [blockScroll]="true"
  [dismissableMask]="true"
  [style]="{ width: '80vw', height: '85vh' }"
  appendTo="body"
  (onHide)="onHide()"
>
  <ng-template pTemplate="header">
    <div class="flex items-center gap-3 min-w-0">
      <span class="font-semibold truncate">{{ file?.name }}</span>
      @if (file) {
        <p-button
          size="small"
          [text]="true"
          icon="pi pi-download"
          [label]="'animalDocuments.item.btnDownload' | transloco"
          (onClick)="download()"
        />
      }
    </div>
  </ng-template>

  @if (file) {
    <div class="relative h-full w-full">
      @if (file.kind === 'image') {
        <app-animal-image-container
          [id]="file.id"
          [variant]="'full'"
          [preview]="false"
          class="max-h-[70vh] max-w-full"
        />
      } @else if (file.kind === 'video') {
        <app-animal-video-container
          [animal]="animal"
          [id]="file.id"
          class="max-h-[70vh] max-w-full"
        />
      } @else if (previewUrl) {
        <iframe
          [src]="previewUrl"
          class="w-full h-[70vh] border-0"
          [title]="'animalDocuments.aria.preview' | transloco"
        ></iframe>
      } @else {
        <div class="flex flex-col items-center justify-center gap-4 h-[60vh] text-center">
          <i class="{{ icon }} text-7xl"></i>
          <span class="text-sm text-gray-600 break-all px-4">{{ file.name }}</span>
          <span class="text-gray-500">{{ 'animalDocuments.previewUnavailable' | transloco }}</span>
          <p-button
            [label]="'animalDocuments.item.btnDownload' | transloco"
            icon="pi pi-download"
            (onClick)="download()"
          />
        </div>
      }
    </div>
  }
</p-dialog>
